// extracted by mini-css-extract-plugin
export default {"module":"copywriting_module__gpdUu","materialBox":"copywriting_materialBox__7hrUC","materialImg":"copywriting_materialImg__dxQKx","btn":"copywriting_btn__zyIFw"};